import {normalize} from 'normalizr';
import {receiveEntities, updateEntities} from '../entities';
import {userSchema} from '../../schemas/user';

import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_FETCH_USER = 'REQUEST_FETCH_USER';
export const SUCCESS_FETCH_USER = 'SUCCESS_FETCH_USER';
export const FAIL_FETCH_USER = 'FAIL_FETCH_USER';

export const fetchUser = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_USER, payload, scope});

    fetch(getEndpoint('fetchUser', encodeURIComponent(payload.identifier)), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_USER,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchUser(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_USER) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchUser(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, userSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_USER,
      receivedAt: Date.now(),
      id: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_PROFILE = 'REQUEST_FETCH_PROFILE';
export const SUCCESS_FETCH_PROFILE = 'SUCCESS_FETCH_PROFILE';
export const FAIL_FETCH_PROFILE = 'FAIL_FETCH_PROFILE';

export const fetchProfile = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_PROFILE, payload, scope});

    fetch(getEndpoint('fetchProfile'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_PROFILE});
        else dispatch(successFetchProfile(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_PROFILE) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchProfile(data, payload, scope) {
  return dispatch => {
    const normalized = normalize(data, userSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_PROFILE,
      receivedAt: Date.now(),
      user: data,
      payload,
      scope,
    });
  };
}

export const getUserVersions = (userId, onSuccess) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('getUserVersions', userId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (!data.error) {
          if (onSuccess) onSuccess(data);
        }
      });
    // .catch((error, type = FAIL_USER_VERSIONS) => { dispatch({ type, error, payload, scope }); });
  };
};

export const REQUEST_REMOVE_USER = 'REQUEST_REMOVE_USER';
export const SUCCESS_REMOVE_USER = 'SUCCESS_REMOVE_USER';
export const FAIL_REMOVE_USER = 'FAIL_REMOVE_USER';

export const removeUser = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_REMOVE_USER, payload, scope});

    fetch(getEndpoint('removeUser', payload.userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_REMOVE_USER,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successRemoveUser(data, payload, scope));
      })
      .catch((error, type = FAIL_REMOVE_USER) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successRemoveUser(response, payload, scope) {
  return {
    type: SUCCESS_REMOVE_USER,
    receivedAt: Date.now(),
    success: response.success,
    payload,
    scope,
  };
}

export const REQUEST_FORCE_USER_PASSWORD = 'REQUEST_FORCE_USER_PASSWORD';
export const SUCCESS_FORCE_USER_PASSWORD = 'SUCCESS_FORCE_USER_PASSWORD';
export const FAIL_FORCE_USER_PASSWORD = 'FAIL_FORCE_USER_PASSWORD';

export const forceUserPassword = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FORCE_USER_PASSWORD, payload, scope});

    fetch(getEndpoint('forceUserPassword', payload.userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FORCE_USER_PASSWORD,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successForceUserPassword(data, payload, scope));
      })
      .catch((error, type = FAIL_FORCE_USER_PASSWORD) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successForceUserPassword(response, payload, scope) {
  return {
    type: SUCCESS_FORCE_USER_PASSWORD,
    receivedAt: Date.now(),
    success: response.password,
    payload,
    scope,
  };
}

export const REQUEST_HIDE_USER_LEAGUE = 'REQUEST_HIDE_USER_LEAGUE';
export const SUCCESS_HIDE_USER_LEAGUE = 'SUCCESS_HIDE_USER_LEAGUE';
export const FAIL_HIDE_USER_LEAGUE = 'FAIL_HIDE_USER_LEAGUE';

export const hideUserLeague = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_HIDE_USER_LEAGUE, payload});
    if (onRequest) onRequest(payload);

    fetch(
      getEndpoint(payload.hide ? 'hideUserLeague' : 'showUserLeague', payload),
      {
        method: 'POST',
        headers: getHeaders(getState().authentication),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          dispatch({type: FAIL_HIDE_USER_LEAGUE});
          if (onFail) onFail(FAIL_HIDE_USER_LEAGUE, data.error);
        } else {
          dispatch({type: SUCCESS_HIDE_USER_LEAGUE, data});
          if (onSuccess) onSuccess(data, payload);
        }
      })
      .catch((error, type = FAIL_HIDE_USER_LEAGUE) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const fetchUserPurchases = (payload, scope, onSuccess, onError) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('fetchUserPurchases', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
        } else {
          if (onSuccess) onSuccess(data);
        }
      })
      .catch(error => {
        if (onError) onError(error);
      });
  };
};

export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
export const SUCCESS_UPDATE_USER = 'SUCCESS_UPDATE_USER';
export const FAIL_UPDATE_USER = 'FAIL_UPDATE_USER';

export const updateUser = (payload, scope, onSuccess, onError, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_USER, payload, scope});
    if (onRequest) onRequest(payload);
    fetch(getEndpoint('updateUser', payload.id), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({...payload, id: undefined}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          dispatch({type: FAIL_UPDATE_USER, error: data.error, scope});
          if (onError) onError(data.error);
        } else {
          if (scope !== 'UpdateOptinsNotifications') {
            dispatch(
              updateEntities([{id: payload.id, changes: payload}], 'users'),
            );
          }
          dispatch({
            type: SUCCESS_UPDATE_USER,
            receivedAt: Date.now(),
            id: payload.id,
            scope,
          });
          if (onSuccess) onSuccess(data);
        }
      })
      .catch(error => {
        dispatch({type: FAIL_UPDATE_USER, error});
        if (onError) onError(error);
      });
  };
};

export const REQUEST_FETCH_ALERTS_BY_USER = 'REQUEST_FETCH_ALERTS_BY_USER';
export const SUCCESS_FETCH_ALERTS_BY_USER = 'SUCCESS_FETCH_ALERTS_BY_USER';
export const FAIL_FETCH_ALERTS_BY_USER = 'FAIL_FETCH_ALERTS_BY_USER';

export const fetchAlertsByUser = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_ALERTS_BY_USER, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchAlertsByUser', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_ALERTS_BY_USER});
        else dispatch({type: SUCCESS_FETCH_ALERTS_BY_USER, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_ALERTS_BY_USER) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/user.js